import { ChangeDetectionStrategy, Component, OnInit, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { createInjectableType } from '@angular/compiler';
import { ActivatedRoute, NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { TranslateDirective, TranslatePipe } from '@ngx-translate/core';
import { DataSummaryStore } from 'src/app/features/questionnaires/store/data-summary-store';
import { DataToolbarComponent } from './components/data-toolbar/data-toolbar.component';
import { toSignal } from '@angular/core/rxjs-interop';
import { DataSummaryApiService } from 'src/app/features/questionnaires/services/data-summary-api-service';
import { AnswersStore } from 'src/app/store/answers-store';
import { QuestionnaireStore } from 'src/app/store/questionnaire-store';
import { SvgIconComponent } from 'angular-svg-icon';
import { DragStore } from 'src/app/store/drag-store';
import { QueDatePipe } from 'src/app/pipes/date.pipe';
import { ExportReportComponent } from "./export-report/export-report.component";
import { OverlayModule } from '@angular/cdk/overlay';
import { MatDialog } from '@angular/material/dialog';
import { ExportDataRespons, ReportType } from '../ExportDataRespons';
import { StepperComponent } from "../../../../../create-questionnaire-page/component/steps-menu/stepper/stepper.component";
import { environment } from 'src/environment';

@Component({
    selector: 'que-questionnaire-data',
    imports: [CommonModule, RouterOutlet, TranslateDirective, TranslatePipe, DataToolbarComponent, SvgIconComponent, QueDatePipe, ExportReportComponent, OverlayModule, StepperComponent],
    providers: [DataSummaryStore, AnswersStore, QuestionnaireStore, DragStore],
    templateUrl: './questionnaire-data.component.html',
    styleUrls: ['./questionnaire-data.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class QuestionnaireDataComponent {
  #router = inject(Router)
  #dataStore = inject(DataSummaryStore)
  #dataSummaryApiService = inject(DataSummaryApiService)
  // steps$ = this.#dataStore.steps$;
  currentStep$ = toSignal(this.#dataStore.currentStep$);
  displayState$ = toSignal(this.#dataStore.displayState$);
  //בהתאמה url
  #activeRoutes = inject(ActivatedRoute);
  #dialog = inject(MatDialog);
  id = 0;
  name$ = toSignal(this.#dataStore.name$);
  recipients$ = toSignal(this.#dataStore.recipients$);
  date$ = toSignal(this.#dataStore.createDate$);
  isDataForAllSig$ = this.#dataStore.isDataForAllSig$;
  showComparison$ = toSignal(this.#dataStore.showComparison$);
  isQuestionnarieParent$ = toSignal(this.#dataStore.isQuestionnarieParent$);
  lastUrlSegment = "";
  isOpenExport = false;
  apiExposureEnabled = environment.apiExposureEnabled;
  loadingData$ = toSignal(this.#dataStore.loadingData$);
  stepsNames$ = toSignal(this.#dataStore.stepsNames$)

  finishAnsweredTheQuestionnaire$ = toSignal(this.#dataStore.finishAnsweredTheQuestionnaire$);
  constructor() {

    this.#activeRoutes.params.subscribe(
      p => {
        this.id = p['id'];
        this.#dataStore.updateCurrentId(this.id);
        this.#dataStore.getQuestionDataSummaryFirst(this.id);
        if (environment.apiExposureEnabled == true) {
          this.#dataStore.getApiExposureData(this.id);
        }
        this.#dataStore.getAnsweredQuestionnaireData(this.id)
      }
    )
  }
  // ngOnInit(): void {
  //      // Subscribe to router events
  //      this.#router.events.subscribe((event) => {
  //       if (event instanceof NavigationEnd) {
  //         this.updateLastUrlSegment(event.url);
  //       }
  //     });

  //     // Get the initial route snapshot and set lastUrlSegment
  //     this.updateLastUrlSegment(this.#router.url);
  // }
  // private updateLastUrlSegment(url: string): void {
  //   const segments = url.split('/');
  //   this.lastUrlSegment = segments[segments.length - 1];
  // }

  return() {
    this.#router.navigate(['main', `grid`, `questionnaires`])
  }
  resetFilters() {
    this.#dataStore.updateCurrentFilter(undefined);
    this.#dataStore.updateCurrentRecipientIdToFilter(undefined);
  }
  navToSummary() {
    this.resetFilters();
    this.#router.navigate([`data`, this.id, "summary"]);
  }
  navToSubmissions() {
    this.resetFilters();
    this.#router.navigate(['data', this.id, "submissions"]);
  }
  navToAnswered() {
    this.resetFilters();
    this.#router.navigate(['data', this.id, "answeredTheQuestionnaire"]);
  }
  navToApiExposure() {
    this.resetFilters();
    this.#dataStore.getApiExposureData(this.id);
    this.#router.navigate(['data', this.id, "apiExposure"]);
  }
  changeStep(step: number) {
    this.#dataStore.updateCurrentStep(step);
  }
  exportReport() {
    this.#dialog.open(ExportReportComponent, {
      data: { users: this.finishAnsweredTheQuestionnaire$(), isShowComparison: this.isQuestionnarieParent$() },
      panelClass: 'dialog-panel',
      autoFocus: false
    }).afterClosed().subscribe(
      x => {
        if (x) {
          var res = x as ExportDataRespons;
          if (res.reportType == ReportType.CSV) {
            this.#dataSummaryApiService.exportDataToExcel(this.id, res.isComparison, this.name$(), this.date$())
          }
          else {
            if (res.reportType == ReportType.PDF) {
              this.#dataSummaryApiService.exportDataToPdf(this.id, this.name$(), res.users)
            }
          }
        }
      }
    );
  }
  // xx() {
  //   this.#dataSummaryApiService.exportDataToPdf(this.id, this.name$(), [1283])
  // }
  changePage(index: number) {
    this.#dataStore.updateCurrentStep(index);
  }
}
